<template>
  <v-snackbar
    v-model="showConsent"
    :timeout="-1"
    location="bottom"
    multi-line
    color="surface"
  >
    <div class="d-flex flex-column ga-4">
      <p class="text-body-1">
        We use cookies to improve your experience and analyze site usage. 
        <router-link to="/privacy" target="_blank">Learn more</router-link>
      </p>
      <div class="d-flex ga-2 flex-wrap justify-end">
        <v-btn variant="outlined" size="small" @click="declineAnalytics">
          Decline
        </v-btn>
        <v-btn color="primary" size="small" @click="acceptAnalytics">
          Accept Analytics
        </v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { acceptAnalyticsConsent, declineAnalyticsConsent, getAnalyticsConsentStatus } from '@/analytics'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'

@Options({})
export default class CookieConsent extends mixins(AnalyticsMixin) {
  showConsent = false

  mounted() {
    this.checkConsentStatus()
  }

  checkConsentStatus() {
    const consent = getAnalyticsConsentStatus()
    if (!consent) {
      this.showConsent = true
    }
  }

  async acceptAnalytics() {
    await acceptAnalyticsConsent()
    this.showConsent = false

    this.trackEvent('consent_given', {
      event_category: 'privacy',
      consent_type: 'analytics'
    })
  }

  declineAnalytics() {
    declineAnalyticsConsent()
    this.showConsent = false
  }
}
</script>
